import { ColumnSortType, TableColumnTypes } from '../../../../model/table.model';

export const tableHeaders = [
  {
    value: 'primary',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.CHECKBOX,
    className: 'table-checkbox'
  },
  {
    value: 'images',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.OLX_IMAGE,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'title',
    sort: ColumnSortType.NONE,
    name: 'Назва',
    type: TableColumnTypes.TITLE,
    className: 'table-header',
  },
  {
    value: 'description',
    sort: ColumnSortType.NONE,
    name: 'Опис',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'status',
    sort: ColumnSortType.NONE,
    name: 'Статус',
    type: TableColumnTypes.OLX_ADVERT_STATUS,
    className: 'table-header',
  },
  {
    value: 'price_value',
    sort: ColumnSortType.NONE,
    name: 'Ціна',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'contact_name',
    sort: ColumnSortType.NONE,
    name: 'Контакт Назва',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'contact_phone',
    sort: ColumnSortType.NONE,
    name: 'Контакт Телефон',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'url',
    sort: ColumnSortType.NONE,
    name: 'Силка',
    type: TableColumnTypes.LINK,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'Створений',
    type: TableColumnTypes.DATE,
    className: 'table-header',
  },
  {
    value: 'valid_to',
    sort: ColumnSortType.NONE,
    name: 'Доступний до',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'planned_at',
    sort: ColumnSortType.NONE,
    name: 'Дата наступної активації',
    type: TableColumnTypes.DATETIME,
    className: 'table-header',
    disabled: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        { icon: 'toggle_on', label: 'activate_now', value: 'ACTIVE_NOW', color_icon: 'green' },
        { icon: 'toggle_off', label: 'deactivate_now', value: 'DEACTIVATE_NOW', color_icon: 'red' },
        { icon: 'schedule', label: 'plan_activation', value: 'ACTIVE_PLAIN', color_icon: 'gray' },
        // { icon: 'vertical_align_top', label: 'Підняття вгору списку', value: 'PUSHUP', color_icon: 'green' },
        // { icon: 'paid', label: 'Рекламувати', value: 'PAID', color_icon: 'blue' },
      ],
    translate: true,
  },
];
